import React, { useState, useEffect } from 'react'
import ResponseMsg from '../general/ResponseMsg';
import extraImg from '../assets/empty-cart.gif';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Loading from '../general/Loading';


const SubOrderHistory = ({userData}) => {
  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  // const [showUpdate, setShowUpdate] = useState(false);
  // const [response, setResponse] = useState(null);
  const [showInvoice, setShowInvoice] = useState(false);
  // const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [assignedOrder, setAssignedOrder] = useState([]);
  // const [showDelivery, setShowDelivery] = useState(false);
  const [orderAddress, setOrderAddress] = useState('');


  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-store-orders/${userData.id}`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setOrders(sortedProducts);
        } else {
        setLoading(false);
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

    fetchOrders();
  }, []);


  useEffect(() => {
    const fetchAssignedOrder = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-assigned-order');
        if (response.ok) {
          const data = await response.json();
          setAssignedOrder(data);
        } else {
          console.error('Failed to fetch staff members');
        }
      } catch (error) {
        console.error('Error fetching staff:', error);
      }
    };

    fetchAssignedOrder();
  }, []);


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };


  const filteredOrders = orders
  .map(order => {
    const allItems = JSON.parse(order.order_items);
    // const orderItems = allItems.filter(item => item.subadmin_id === userData.id);

    return { ...order, filteredItems: allItems };
  })
  .filter(order => {
    if (order.filteredItems.length === 0) return false;

    const isDateMatch = formatDate(order.order_date).toLowerCase().includes(searchQuery.toLowerCase());
    const isStatusMatch = order.order_status.toLowerCase().includes(searchQuery.toLowerCase());
    const isUserMatch = order.user_name.toLowerCase().includes(searchQuery.toLowerCase());
    const isProductNameMatch = order.filteredItems.some(item =>
      item.product_name.toLowerCase().includes(searchQuery.toLowerCase())
    );

     const isOrderIdMatch = order.id.toString().includes(searchQuery.toLowerCase());
    return isOrderIdMatch || isDateMatch || isStatusMatch || isUserMatch || isProductNameMatch;
  });


  const handleShowInvoice = (order) => {
    setSelectedProduct(order);
    console.log(selectedProduct);
    setShowInvoice(true);
  }

  const handlePrint = () => {
    setTimeout(() => {
      window.print();  // Trigger the print dialog
    }, 200);  // Wait 200ms for content to load before triggering print
  };


    const getOrderLocation = async (lat, lon) => {
      try {
          const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
          const data = await response.json();
  
          return data.display_name || 'Unknown location';
      } catch (error) {
          console.error('Error fetching order address:', error);
          return 'Failed to fetch location';
      }
  };
  
    useEffect(() => {
      const fetchOrderAddress = async () => {
          if (selectedProduct?.lat && selectedProduct?.longi) {
              const address = await getOrderLocation(selectedProduct.lat, selectedProduct.longi);
              setOrderAddress(address);
          } else {
              setOrderAddress(`${selectedProduct.user_location || selectedProduct.user_address}, ${selectedProduct.user_city}, ${selectedProduct.user_state}, ${selectedProduct.user_pincode}`);
          }
      };
  
      fetchOrderAddress();
  }, [selectedProduct]);
  

  return (
    <>
      <section className='py-4 bg-light'>
        <div className='px-3'>

          <div className='d-flex'>
            <p className='sec-heading'>Orders History</p>
            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Manage</span>
          </div>

          <div className="text-start mb-4">
            <input
              type="text"
              className="form-input rounded border-0"
              placeholder="🎯 Search order here..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className='bg-white px-3 py-3 rounded-4'>

            {filteredOrders.length > 0 ? (
              filteredOrders.map((order) => {
const orderItems = order.filteredItems;                
                // const orderItems = JSON.parse(order.order_items);
                return (
                  <div className='my-3' key={order.id}>
                    <div className='order-area'>
                      <p className='fw-semibold my-0'>Order placed on {formatDate(order.order_date)}</p>
                      <p className='text-muted fw-semibold para-text'>Order Id: {order.id}<br />Customer Name: {order.user_name}<br />
                      </p>
                      <Swiper spaceBetween={20} slidesPerView={6} modules={[Navigation]} loop={true}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        breakpoints={{
                          0: {
                            slidesPerView: 2,
                          },
                          768: {
                            slidesPerView: 4,
                          },
                          992: {
                            slidesPerView: 6,
                          }
                        }}>

                        {orderItems.length > 0 ? (
                          orderItems.map((item, index) => (
                            <>
                              <hr />
                              <SwiperSlide key={index} className='my-2'>
                                <img
                                  src={`https://api.kcmstore.in/sUploads/${item.image.split(',')[0]}`}
                                  className='img-fluid'
                                  alt='Order'
                                />
                                {/* <p className='mb-0 fw-semibold'>{item.product_name}</p> */}
                              </SwiperSlide>
                            </>
                          ))
                        ) : (
                          <p>No items in this order</p>
                        )}
                      </Swiper>
                      {/* <p className='mt-3 text-muted fw-semibold para-text'>Payment Mode: {order.payment_mode}<br />Payment Id: {order.payment_id || 'NA'}<br />Payment Status: {order.payment_status}</p> */}
                      <p className='text-muted fw-semibold mt-3'>Order Total ₹ {order.total_amount}<br />This Order has been {order.order_status}</p>

                      {(() => {
  const assignedAgent = assignedOrder.find(item => item.order_id == order.id);

  return (
    <>
      <hr />
      {assignedAgent ? (
        <p className='fw-semibold para-text text-muted'>
          Delivery Agent: {assignedAgent.delivery_agent_name}<br />
          {assignedAgent.delivery_agent_phone}
        </p>
      ) : (
        <p className='fw-semibold para-text text-muted'>No Delivery Agent Assigned yet</p>
      )}
    </>
  );
})()}

                      <div className='d-md-flex mt-3'>
                        <button className='order-btn mx-1 my-1 w-100' onClick={() => handleShowInvoice(order)}>Order Invoice 📃</button>

                      </div>
                    </div>
                  </div>
                );

              })
            ) : (
              <div className='text-center'>
                <img src={extraImg} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                <p>No Orders Placed yet</p>
              </div>
            )}

          </div>
          {/* row ends */}

        </div>
      </section>



      {showInvoice && selectedProduct && orderAddress && (
        <>
          <section className='invoice-dialog px-2' onClick={() => setShowInvoice(false)}>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-start' onClick={(e) => e.stopPropagation()}>

              <p className='sec-heading fs-4'>Order Invoice</p>

              <div className='invoice-area my-4'>
                <div className='row'>
                  <p className='col-md-8'><span className='fw-semibold'>Customer Details:</span><br />Name: {selectedProduct.user_name}<br />Mobile No: {selectedProduct.user_phone}<br /> 
                  Delivery Address: {orderAddress}</p>
                  <p className='col-md-4'><span className='fw-semibold'>Order Details:</span><br />Order id: {selectedProduct.id}<br />Placed On: {formatDate(selectedProduct.order_date)}</p>
                </div>
                {/* flex ends */}
                <hr />

                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th className='px-2 py-2'>Product</th>
                    <th className='px-2 py-2'>MRP ₹</th>
                      <th className='px-2 py-2'>Qty</th>
                    <th className='px-2 py-2'>Discount</th>
                    <th className='px-2 py-2'>Total ₹</th>
                    </tr>

                    {typeof selectedProduct.order_items === 'string' ? (
                      (() => {
                        try {
                          const parsedItems = JSON.parse(selectedProduct.order_items);

 if (Array.isArray(parsedItems)) {
                            return parsedItems.map((item, index) => (
                              <tr key={index}>
                                <td className='px-2 py-2'>{item.product_name}</td>
                      <td className='px-2 py-2'>{item.org_price}</td>
                                <td className='px-2 py-2'>{item.quantity}</td>
                      <td className='px-2 py-2'>{item.discount_type == 'amount' ? '₹' : ''} {item.discount_amount} {item.discount_type == 'percent' ? '%' : ''}</td>
                                <td className='px-2 py-2'>{item.product_price * item.quantity}</td>

                              </tr>
                            ));
                          }
                        } catch (error) {
                          return <p>Failed to get items.</p>
                        }
                      })()
                    ) : (
                      <p>No items available.</p>
                    )}

                  </table>
                </div>
                {/* table area */}

                <hr />

{selectedProduct?.order_items && (() => {
  try {
    const items = JSON.parse(selectedProduct.order_items);

    // Sum total price
    const total = items.reduce((sum, item) => sum + Number(item.product_price) * Number(item.quantity), 0);

    return (
      <>
      <p className='text-end my-0 para-text'>
        Order Total: ₹{total.toFixed(2)}<br />
        Platform Fee: ₹{selectedProduct?.platform_fee}<br />
        Delivery Charges: ₹{selectedProduct?.delivery_charge}
      </p>
            <p className='text-end my-0 fw-semibold para-text border-top my-2 py-2 border-bottom'>
              Sub Total: ₹{(Number(total) + Number(selectedProduct?.platform_fee) + Number(selectedProduct?.delivery_charge)).toFixed(2)}
</p>
      </>
    );
  } catch {
    return null;
  }
})()}

{selectedProduct?.coupon_applied && (() => {
  try {
    const coupon = JSON.parse(selectedProduct.coupon_applied);
    return (
      <p className='text-end my-0 para-text border-top my-2 py-2 border-bottom'>
        Coupon Applied: {coupon.coupon_code} <br />
        Discount: {coupon.discount_type === 'percent'
          ? `${coupon.discount_amount}%`
          : `₹${coupon.discount_amount}`}
      </p>
    );
  } catch {
    return null;
  }
})()}

                <p>Grand Total: ₹{selectedProduct.total_amount}<br />Payment Mode: {selectedProduct.payment_mode} <br />Payment Id: {selectedProduct.payment_id || 'NA'} <br />Payment Status: {selectedProduct.payment_status}</p>

                {/* <p>Grand Total ₹{selectedProduct.total_amount}<br />Payment Mode: {selectedProduct.payment_mode} <br />Payment Id: {selectedProduct.payment_id || 'NA'} <br />Payment Status: {selectedProduct.payment_status}</p> */}
                <p>This Order has been {selectedProduct.order_status}.</p>

              </div>
              {/* invoice ends */}
              <button className='danger-btn' onClick={() => setShowInvoice(false)}>Close</button>&nbsp;&nbsp;
              <button className='success-btn' onClick={handlePrint}>Download</button>


            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default SubOrderHistory
